import { defineStore } from "pinia";
import { watch } from "vue";
import { config } from "@/config.js";
import { useUserDataStore } from "@/stores/userData.js";

export const useOwnedGamesStore = defineStore('ownedGames', {
    state: () => ({ ownedGames: [], isPrivate: null }),
    actions: {
        setOwnedGames(games) {
            this.ownedGames = games;
        },
        async init() {
            const response = await fetch(config.backendUrl + "/user/games", { credentials: "include" });


            if (response.ok) {
                const games = await response.json();
                this.setOwnedGames(games);
                this.isPrivate = false;
            } else {
                console.error("Failed to fetch owned games:", response.statusText);
                if (response.status === 404) {
                    this.isPrivate = true;
                }
            };

            const userDataStore = useUserDataStore();

            // Watch for changes in user login state to refetch owned games
            watch(
                () => userDataStore.isLoggedIn,
                async (newUser) => {
                    if (newUser) {
                        const response = await fetch(config.backendUrl + "/user/games", { credentials: "include" });
                        if (response.ok) {
                            const games = await response.json();
                            this.setOwnedGames(games);
                        } else {
                            console.error("Failed to fetch owned games:", response.statusText);
                        }
                    } else {
                        this.setOwnedGames([]);
                    }
                }
            );
        },
        getOwnedGames() {
            return this.ownedGames;
        },
        getOwnedGamesSortedByName() {
            return this.ownedGames.slice().sort((a, b) => a.game.name.localeCompare(b.game.name));
        },
        getOwnedGamesByLastPlayed() {
            return this.ownedGames.slice().sort((a, b) => b.lastPlayedTimestamp - a.lastPlayedTimestamp);
        },
        getOwnedGamesByPlaytime() {
            return this.ownedGames.slice().sort((a, b) => b.minutes - a.minutes);
        },
        
    },
});